import { Tooltip } from '@mui/material'
import { ReactNode } from 'react'

const SEPARATOR = ' — '

interface EditorModalHeaderProps {
	attributeLabel: ReactNode
	elementLabel?: ReactNode
}

const toText = (value: ReactNode): string =>
	value === undefined || value === null || typeof value === 'boolean'
		? ''
		: String(value)

/**
 * Single-line header for popup/fullscreen attribute editors.
 * Renders `attribute` or `attribute — element`, truncated with an ellipsis
 * and a tooltip revealing the full text.
 */
export const EditorModalHeader = ({
	attributeLabel,
	elementLabel,
}: EditorModalHeaderProps) => {
	const attributeText = toText(attributeLabel)
	const elementText = toText(elementLabel)
	const fullText = elementText
		? `${attributeText}${SEPARATOR}${elementText}`
		: attributeText

	return (
		<Tooltip title={fullText} arrow>
			<span
				data-testid="editor-modal-header"
				style={{
					display: 'block',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
					maxWidth: '100%',
					fontWeight: 600,
				}}
			>
				{attributeText}
				{elementText && (
					<span style={{ fontWeight: 400, opacity: 0.7 }}>
						{SEPARATOR}
						{elementText}
					</span>
				)}
			</span>
		</Tooltip>
	)
}
